import useApi from '../../api/backendApiContext';
import useAuth from '../../auth/authContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import { useQuery } from '@tanstack/react-query';
import { ReactQueryConstants } from '../../commons/constants';
import { QueryStatus } from '../../commons/components/QueryStatus';
import { ONBOARDING_STATE_NOT_OFFERED, OnboardingProgressDto } from '../../user/userApi';

export const useFetchedOnboardingProgress = () => {
  const { userApi } = useApi();
  const {
    state: { user },
  } = useAuth();
  const queryCacheManager = useQueryCacheManager();
  const queryKey = queryCacheManager.getOnboardingProgressCacheKey();
  const query = useQuery(
    queryKey,
    async (): Promise<OnboardingProgressDto> =>
      user
        ? userApi.getOnboardingProgress(user.userId)
        : Promise.resolve({ state: ONBOARDING_STATE_NOT_OFFERED, steps: [] }),
    {
      staleTime: ReactQueryConstants.chatsStaleTime,
      refetchInterval: ReactQueryConstants.chatsRefetchInterval,
      refetchOnWindowFocus: true,
    }
  );
  const queryStatusComponent = (
    <QueryStatus
      queryKey={queryKey}
      queryStatus={query.status}
      dataTestPrefix="onboarding-progress"
      failedToLoadText={`Something went wrong while loading data. Please try again or contact support@growegy.com if the issue persists.`}
    />
  );

  return { query, queryStatusComponent };
};
